/**
 * Global JS
 */

// CSS
import styles from '../scss/index.scss';

// Vendors
import $ from 'jquery';
import 'fancybox/dist/js/jquery.fancybox.pack';
import 'jquery.maskedinput/src/jquery.maskedinput';
import './lib/wl-share';
import AOS from 'aos';

// Framework
import carousels from './framework/carousel';
import code from './framework/code';
import dropdowns from './framework/dropdown';
import modals from './framework/modal';
import notices from './framework/notice';
import toggles from './framework/toggle';
import tooltips from './framework/tooltip';
import utilities from './framework/utilities';

// Site modules
import './site/back-to-top';
import './site/header';
import './site/media-carousel';
import './site/parallax';
import './site/nav-mobile';
import './site/tabbed-media-carousel';
import VideoModal from './site/video-modal';
import './lib/polyfils';

// Helpers
import { linkOutAlert, openPopUpWindow } from './lib/helpers';

$(document).on('click', 'a', linkOutAlert);

AOS.init({
  duration: 1000,
  once: true,
});

// Apply input masks
$('.mask-input-phone').mask('(999) 999-9999');
$('.mask-input-date').mask('99/99/9999');

// Init Fancybox
$('.fancybox').fancybox({
  helpers: {
    overlay: {
      locked: false, // Prevent page from jumping back to top
    },
  },
});

// Init Video Modal
const videoModalInstance = new VideoModal();
videoModalInstance.init();

// Init single carousel
const carouselSingle = carousels('[data-carousel="single"]', {
  autoplay: true,
  autoplaySpeed: 4000,
  speed: 800,
  dots: true,
  infinite: true,
});

// Init multiple carousel
const carouselMultiple = carousels('[data-carousel="multiple"]', {
  autoplay: false,
  dots: true,
  infinite: true,
  slidesToShow: 2,
  slidesToScroll: 2,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
});

// Init modals
modals('[data-modal]');

// Init toggles
toggles('[data-toggle-target]');

// Init notices
notices('[data-notice-dismissible]');

// Init code
code('[data-code]');

// Init tooltips
tooltips('[data-tooltip]');

// Init dropdowns
dropdowns('[data-dropdown]');

// Init openPopUpWindow function
$('[data-action-popup]').click(event => {
  event.preventDefault();
  openPopUpWindow(event.currentTarget.href);
});
